import { render, staticRenderFns } from "./DecisionDiamondComparison.vue?vue&type=template&id=6c73f162&scoped=true"
import script from "./DecisionDiamondComparison.vue?vue&type=script&lang=js"
export * from "./DecisionDiamondComparison.vue?vue&type=script&lang=js"
import style0 from "./DecisionDiamondComparison.vue?vue&type=style&index=0&id=6c73f162&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c73f162",
  null
  
)

export default component.exports